import React from 'react';
import { makeStyles, Grid, Tabs, Tab, CircularProgress } from '@material-ui/core';

import { FormattedMessage } from 'react-intl';

import styles from './styles';

const useStyles = makeStyles(styles);

export default function RenderTabs({
  view,
  mainColor,
  loadingDocuments,
  isInternalForm,
  documentsStore,
  handleViewChange,
  renderViewsDocumentation = true,
}) {
  const classes = useStyles();

  return (
    <Grid container spacing={3} className={classes.tabsContainer}>
      <Tabs
        variant="scrollable"
        onChange={handleViewChange}
        className={classes.tabs}
        indicatorColor={mainColor ? mainColor : 'primary'}
        textColor={mainColor ? mainColor : 'primary'}
        value={view}
      >
        <Tab className={classes.tab} label="Solicitação" />
        {loadingDocuments && !isInternalForm && (
          <Tab
            className={classes.tab}
            label={<CircularProgress size={12} className={classes.loading} />}
          />
        )}
        {renderViewsDocumentation && !isInternalForm && !loadingDocuments && (
          <Tab
            className={classes.tab}
            label={<FormattedMessage id="LABELS.COMMONS.DOCUMENTATION" />}
          />
        )}
      </Tabs>
    </Grid>
  );
}
